import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Inquiry from "./Inquiry";

const InquiryList = () => {
  return (
    <div
      id="contact"
      className="relative w-full h-full bg-[url('../public/images/contactBg.png')] bg-cover bg-fixed bg-center py-14 lg:py-28 xl:py-36"
    >
      <div className="relative w-full h-full px-3 max-w-screen-xl mx-auto">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-3 text-black"
        >
          <div className="font-normal flex justify-start items-center flex-wrap lg:flex-nowrap gap-2">
            <div className=" relative w-fit h-fit">
              <img
                alt="키플레이어 도어락 상담문의 안내"
                className="!relative w-auto h-full max-h-8 lg:max-h-12 pt-1 pb-2 object-contain cursor-pointer"
                src="/images/contactTitle.png"
                width={272}
                height={132}
              />
            </div>
          </div>
        </div>
        <div className="relative w-full h-fit mx-auto grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div
            data-aos="fade-right"
            className=" relative w-full h-full bg-light pt-3 px-3 lg:pt-5 lg:px-5 rounded-3xl"
          >
            <Inquiry />
          </div>
          <div data-aos="fade-left" className="relative w-full h-full">
            <div className="mb-3 bg-primary text-white py-4 text-center border-2 border-point rounded-xl">
              <h3 className="flex items-end justify-center gap-0.5 font-medium">
                <img
                  alt="키플레이어 도어락 로고"
                  className="!relative w-auto h-full max-h-8 lg:max-h-9 py-1 object-contain cursor-pointer"
                  src="/images/logo.png"
                  width={531}
                  height={65}
                />
                <span className="-mb-1.5 lg:-mb-2">실시간&nbsp;견적현황</span>
              </h3>
            </div>
            <InquiryCard />
          </div>
        </div>
      </div>
    </div>
  );
};

function InquiryCard() {
  let slidesviews = 9;
  return (
    <div className="relative w-full h-full bg-light max-h-80 lg:max-h-[465px] rounded-xl shadow-2xl overflow-hidden">
      <Swiper
        spaceBetween={30}
        direction={"vertical"}
        centeredSlides={true}
        loop={true} // loop 여부
        // loopedSlides={3}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        slidesPerView={slidesviews}
        className="mySwiper relative w-full h-full pt-8"
      >
        {inquiries.map((v, i) => (
          <SwiperSlide key={i}>
            <div className="relative w-full h-full grid grid-cols-10 items-center lg:gap-5 lg:px-5 lg:py-2">
              <p className="col-span-3 text-center py-1 w-32 text-sm lg:text-base scale-75 lg:scale-100 bg-primary text-white rounded-full">
                {v.type}
              </p>
              <p className="col-span-2 scale-75 lg:scale-95 text-base">
                {v.createdAt}
              </p>
              <p className="col-span-2 text-center text-base scale-75 lg:scale-100">
                {v.name[0] + "00"}
              </p>

              <div
                className={
                  v.completeYn === "Y"
                    ? "col-span-3 relative w-full h-fit pt-0.5 text-center bg-primary text-white rounded-full"
                    : "col-span-3 relative w-full h-fit pt-0.5 text-center bg-primary text-white rounded-full"
                }
              >
                <p className="text-sm py-1 lg:text-base scale-75 lg:scale-100">
                  {v.completeYn === "Y" ? "상담완료" : "상담중"}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default InquiryList;

const inquiries = [
  {
    createdAt: "08:38:26",
    name: "안혜진",
    type: "도어락고장",
    category: "긴급",
    completeYn: "Y",
  },
  {
    createdAt: "08:50:57",
    name: "이영천",
    type: "문잠김해결",
    category: "일반",
    completeYn: "Y",
  },
  {
    createdAt: "10:24:15",
    name: "김리나",
    type: "도어락고장",
    category: "일반",
    completeYn: "N",
  },
  {
    createdAt: "12:15:20",
    name: "전리나",
    type: "손잡이교체",
    category: "긴급",
    completeYn: "Y",
  },
  {
    createdAt: "13:21:49",
    name: "박리나",
    type: "손잡이교체",
    category: "긴급",
    completeYn: "Y",
  },
  {
    createdAt: "13:52:15",
    name: "김리나",
    type: "도어락고장",
    category: "긴급",
    completeYn: "Y",
  },
  {
    createdAt: "20:14:19",
    name: "김리나",
    type: "도어락설치",
    category: "긴급",
    completeYn: "N",
  },
  {
    createdAt: "08:50:57",
    name: "이영천",
    type: "비밀번호분실",
    category: "일반",
    completeYn: "Y",
  },
  {
    createdAt: "10:24:15",
    name: "김리나",
    type: "손잡이교체",
    category: "일반",
    completeYn: "N",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "손잡이교체",
    category: "일반",
    completeYn: "Y",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "손잡이교체",
    category: "일반",
    completeYn: "N",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "손잡이교체",
    category: "일반",
    completeYn: "N",
  },
  {
    createdAt: "12:15:20",
    name: "전리나",
    type: "손잡이교체",
    category: "긴급",
    completeYn: "N",
  },
  {
    createdAt: "13:21:49",
    name: "박리나",
    type: "도어락설치",
    category: "긴급",
    completeYn: "N",
  },
  {
    createdAt: "14:25:49",
    name: "유리나",
    type: "도어락교체",
    category: "긴급",
    completeYn: "N",
  },
];
